export default __webpack_public_path__ + "static/main1-6fbecf0b764ed91e5cbe7a946bc1bde5.jpg";